import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MembersRoutingModule } from './members-routing.module';
import { CoreModule, ServicesModule } from 'world-archery-lib';
import { MembersRouterInterceptorService } from './details-page/services/members-router-interceptor.service';
import { LeafletModule, LeafletDirective } from '@asymmetrik/ngx-leaflet';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MembersRoutingModule,
    CoreModule,
    ServicesModule,
  ],
  providers:[MembersRouterInterceptorService]
})
export class MembersModule { }
